/**
 * Http header name for "Content-Type" header
 */
export const HTTP_HEADER_CONTENT_TYPE = 'content-type';

/**
 * Http header name for "Accept" header
 */
export const HTTP_HEADER_ACCEPT = 'accept';